<template>
	<div class="sidebar-image-editor">
		<div class="padding-bottom">
			<b-button variant="secondary"
			          @click="openSidebarFor(data)">
				Bild aus MAM laden
			</b-button>
			<b-button class="ml-2"
			          v-if="imageData.value"
			          variant="danger"
			          @click="prepareImageDeletion">
				Bild löschen
			</b-button>
		</div>
		<erco-image-editor :data="imageData" ref="image-editor"></erco-image-editor>
	</div>
</template>

<script>

	import InfoText from '@/helper/infoTextHelper';

	import ErcoImageEditor from '@/components/molecules/ErcoImageEditor';
	import ErcoSidebarImageLoader from '@/components/molecules/ErcoSidebar/ImageLoader';

	export default {
		name: 'ErcoSidebarImageEditorMolecule',
		props: {
			data: {
				type: Object,
			},
		},
		data() {
			return {
				currentData: null,
			};
		},
		computed: {
			imageData() {
				return this.currentData || this.data;
			},
		},
		methods: {
			handleApply() {
				if (this.$refs['image-editor'] && this.$refs['image-editor'].handleApply) {
					this.$refs['image-editor'].handleApply();
				}
			},
			triggerReset() {
				if (this.$refs['image-editor'] && this.$refs['image-editor'].triggerReset) {
					this.$refs['image-editor'].triggerReset();
				}
			},
			openSidebarFor(item) {
				const sidebarData = {
					visible: true,
					key: 'assets',
					view: 'erco-sidebar-image-loader',
					outputData: item,
					context: {
						dispatchActionName: 'updateAssetsItemFromMAM',
						value: {
							I_Sollbreite: item.I_Sollbreite,
							I_Sollhoehe: item.I_Sollhoehe,
						},
					},
					title: `Bild aus MAM laden - Position ${item.nummer}`,
					titleAdditional: '',
					info: InfoText.for('misc.imageEditor'),
					revert: true,
					doTrack: true,
					closeOnSave: false,
				};
				this.$store.dispatch('updateSidebar', sidebarData);
			},
			prepareImageDeletion() {
				const updatedSidebarContext = Object.assign({}, this.$store.state.sidebar.context);
				updatedSidebarContext.value[this.data.key] =
					Object.assign({}, updatedSidebarContext.value[this.data.key], { value: '' });

				const newSidebarOutputData =
					Object.assign({},
				                  this.data,
				                  updatedSidebarContext.value[this.data.key]);

				this.$set(this, 'currentData', newSidebarOutputData);

				if (this.imageData.PKM_Bild) {
					this.$store.dispatch('deleteImageById', this.imageData.PKM_Bild);
				}

				this.$store.dispatch('updateSidebar', {
					context: updatedSidebarContext,
					outputData: newSidebarOutputData,
				});
			},
		},
		components: {
			ErcoImageEditor,
			'erco-image-loader': ErcoSidebarImageLoader,
		},
	};

</script>

<style lang="scss">

.sidebar-image-editor {
	padding: 0.5rem;
	padding-top: 1.5rem;
	& .padding-bottom {
		padding-bottom: 1.5rem;
	}
}

</style>



// WEBPACK FOOTER //
// ImageEditor.vue?8d8c8f1c